import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, Button, Container } from "react-bootstrap";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Header.css";
import logo_img from "../assets/Impact stories fund logo .png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); // Get current page URL

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Navbar expand="lg" className="custom-navbar-new sticky-top ">
      <Container>
        {/* Logo */}
        <Navbar.Brand as={Link} to="/">
          <img
            src={logo_img}
            alt="Impact Stories Fund Logo"
            style={{ height: "40px" }} // Adjust height as needed
          />
        </Navbar.Brand>

        {/* Hamburger Icon */}
        <div className="hamburger-icon d-lg-none" onClick={toggleMenu}>
          {isOpen ? <FaTimes size={30} /> : <FaBars size={30} />}
        </div>

        {/* Navbar Links Centered (for Large Screens) */}
        <Navbar.Collapse className="justify-content-center">
          <Nav className="mx-auto d-none d-lg-flex">
            {[
              { path: "/", label: "Home" },
              { path: "/about", label: "About Us" },
              { path: "/impact", label: "Our Impact" },
              { path: "/how-it-works", label: "How It Works" },
              // { path: "/our-values", label: "Our Values" },
              { path: "/faq", label: "FAQs" },
              { path: "/contact-us", label: "Contact Us" },
            ].map(({ path, label }) => (
              <Nav.Link
                key={path}
                as={Link}
                to={path}
                className={`nav-link-new ${
                  location.pathname === path ? "active-link" : ""
                }`}
              >
                {label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>

        {/* Give Now Button Aligned to the Right (Large Screens) */}
        {/* <Link to="/donate" className="text-decoration-none">
          <Button
            variant="warning"
            className="give-now-btn-new ms-auto d-none d-lg-block"
          >
            Donate Now!
          </Button>
        </Link> */}

        {/* Mobile Menu (Hamburger) */}
        {isOpen && (
          <div className="mobile-menu-new">
            <div className="menu-header-new">
              <span className="close-icon-new" onClick={toggleMenu}>
                <FaTimes size={30} />
              </span>
            </div>
            <Nav className="d-flex flex-column align-items-center">
              <Nav.Link as={Link} to="/" onClick={toggleMenu}>
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/about" onClick={toggleMenu}>
                About Us
              </Nav.Link>
              <Nav.Link as={Link} to="/impact" onClick={toggleMenu}>
                Our Impact
              </Nav.Link>
              <Nav.Link as={Link} to="/how-it-works" onClick={toggleMenu}>
                How it works
              </Nav.Link>
              <Nav.Link as={Link} to="/faq" onClick={toggleMenu}>
                FAQ
              </Nav.Link>
              <Nav.Link as={Link} to="/contact-us" onClick={toggleMenu}>
                Contact Us
              </Nav.Link>
              {/* <Link to="/donate" className="text-decoration-none">
                <Button
                  variant="warning"
                  className="my-3 fs-5 give-now-btn-new"
                  onClick={toggleMenu}
                >
                  Give Now!
                </Button>
              </Link> */}
            </Nav>
          </div>
        )}
      </Container>
    </Navbar>
  );
};

export default Header;
